// @flow
import moment from "moment";
import { propComparator } from "../../../global/functions/StringOperations";

export function getSoftwareJson(software: *, isAdmin: boolean): * {
  let json = {};
  json.id = software.id;
  json.uuid = software.uuid;
  json.name = software.name;
  json.fileLocation = software.fileLocation;

  const versionObject = software.versions.edges;

  const currentIndex = versionObject.findIndex(item => item.node.isCurrent);

  if (currentIndex > -1) {
    json.currentVersion = getVersion(versionObject[currentIndex].node);
  } else {
    json.currentVersion = getVersion(null);
  }

  let versions = [];
  let betaVersions = [];
  versionObject
    .sort(propComparator("node", false, "releaseDate", null, true))
    .reverse();
  versionObject.forEach((item: *) => {
    if (!item.node.isCurrent) {
      if (item.node.isBeta) {
        betaVersions.push(item.node);
      } else {
        versions.push(item.node);
      }
    }
  });
  json.versions = versions;
  json.betaVersions = betaVersions;

  return json;
}

export function getVersion(version: * | null): * {
  let json = {};

  if (version) {
    json.id = version.id;
    json.versionId = version.versionId;
    json.link = version.link;
    json.releaseDate = moment
      .utc(version.releaseDate)
      .local()
      .format("DD/MMM/YYYY");
    json.releaseDateOrigin = version.releaseDate;
    json.releaseNotes = version.releaseNotes;
    json.isCurrent = version.isCurrent;
    json.isPublic = version.isPublic;
    json.isBeta = version.isBeta;
  } else {
    json.id = "";
    json.versionId = "";
    json.link = "";
    json.releaseDate = "";
    json.releaseNotes = "";
    json.isCurrent = false;
    json.isPublic = false;
    json.isBeta = false;
  }

  return json;
}
